/**
 * Internal dependencies
 */
import { applyEdits } from 'state/utils';
import isEditedLocationGroupDirty from './is-edited-location-group-dirty';
import getLocationGroup from './get-location-group';
import getEdits from './get-edits';

export default (state, id) => {

    id = !id ? "" : id;

    if (isEditedLocationGroupDirty(state, id || "")) {
        let locationGroup = getLocationGroup(state, id);
        let edits = getEdits(state, id);
        locationGroup = applyEdits(locationGroup, edits);
        return locationGroup;
    }

    return getLocationGroup(state, id);
};